import ActivityList, { ActivityListProps } from '@/common/Activity/ActivityList';
import { ComponentPropsWithRef, ReactElement, forwardRef } from 'react';

import Popup from '@/common/Popup';

export type ActivityDrawerProps = ComponentPropsWithRef<typeof Popup> & ActivityListProps;

const ActivityDrawer = (
  { type, resourceId, parentResourceId, ...props }: ActivityDrawerProps,
  ref: React.Ref<HTMLDivElement>
): ReactElement => {
  return (
    <Popup as="drawer" {...props} ref={ref}>
      <ActivityList type={type} resourceId={resourceId} parentResourceId={parentResourceId} />
    </Popup>
  );
};

export default forwardRef(ActivityDrawer);
